import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  body {
    // Make it possible to print multiple pages from react modal with scrolling content
    @media print {
      .ReactModal__Overlay {
        position: absolute !important;
        overflow: visible !important;
      }
      .ReactModal__Content {
        inset: auto !important;
        transform: none !important;
      }
    }
  }
`;
